import type LayoutConfigTypes from "@/core/config/LayoutConfigTypes";
import { brandConfig } from "@/brands/config";

const config: LayoutConfigTypes = {
  general: {
    mode: import.meta.env.VITE_APP_DEFAULT_THEME_MODE || "dark",
    iconsType: "duotone",
  },
  main: {
    type: "default",
    primaryColor: "var(--bs-primary)",
    logo: {
      dark: brandConfig.assets.logoDark,
      light: brandConfig.assets.logoLight,
    },
  },
  illustrations: {
    set: "dozzy-1",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "keenthemes",
    width: "fluid",
    fixed: {
      desktop: false,
      tabletAndMobile: false,
    },
  },
  toolbar: {
    display: true,
    width: "fixed",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  pageTitle: {
    display: true,
    direction: "column",
  },
  aside: {
    display: true,
    theme: "dark",
    fixed: true,
    menuIcon: "keenthemes",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  sidebar: {
    // Whether the Sidebar should be displayed on pages (except for Dashboard, where it's always visible)
    display: false, 
  },
  content: {
    width: "fluid",
  },
  footer: {
    width: "fluid",
  },
};

export default config;
